import type { JSX } from "solid-js/h/jsx-runtime";
import { Icon } from "./Icon";
import "./Search.css";
import searchIcon from "@ms/search.svg?raw";

type Props = {
	onSearch: (value: string) => void;
	value: string;
	onClear: () => void;
	placeholder?: string;
	style?: JSX.CSSProperties | string;
	disabled?: boolean;
};

/**
 * Search input with icon, clear handler, and placeholder.
 *
 * [Design System →](http://localhost:5174/component/Search)
 */
export const Search = (props: Props) => {
	return (
		<div class="gvtui-search" style={props.style}>
			<Icon
				class="icon"
				icon={searchIcon}
				width="18px"
				height="18px"
				display="inline-flex"
			/>
			<input
				type="search"
				onInput={(e) => {
					const value = e.target.value;
					if (value === "") {
						props.onClear();
					} else {
						props.onSearch(value);
					}
				}}
				name="search"
				value={props.value}
				placeholder={props.placeholder ?? "Search..."}
				disabled={props.disabled}
			/>
		</div>
	);
};
